/**
 * Routes
 */
export const RouteConstants = {
  /**
   * Dashboard
   */
  DASHBOARD: "/",
  DASHBOARDS: "/dashboard",
  EVM_DASHBOARD: "/evm-dashboard",
  PROJECTS: "/project",
  PROJECT_LIST: "/project/:type",
  REGISTER_PROJECT: "/register-project",
  PROJECT_SUMMARY: "/project/:id/:tab",
  SUMMARY: "/summary",
  REPORT: "/report",
  USER_MANAGEMENT: "/user-management/:tab",
  FIXED_ASSET: "/fixed-asset/:tab",
  FIXED_ASSET_RECEIVED: "/fixed-asset-received",
  FIXED_ASSET_RETURN: "/fixed-asset-return",
  FIXED_ASSET_TRANSFER_OUT: "/fixed-asset-transfer-out",
  FIXED_ASSET_TRANSFER_IN: "/fixed-asset-transfer-in",
  FIXED_ASSET_ISSUE: "/fixed-asset-issue",
  FIXED_ASSET_TRANSFER: "/fixed-asset-transfer",
  FUEL_ISSUE: "/fuel-issue",
  FUEL_RECEIVING: "/fuel-receiving",
  FIXED_ASSET_REPORT: "/fixed-asset-report",
  FIXED_ASSET_STATUS: "/fixed-asset-status",
  ACQUIRING_STATUS: "/acquiring-status",
  MASTER_LIST: "/master-list",
  FIXED_ASSET_REGISTRY: "/fixed-asset-registry",
  FIXED_ASSET_REGISTRY_STARTING_BALANCE:
    "/fixed-asset-registry-starting-balance",

  MIRAB_REPORT: "/mirab-report",
  DOCUMENT: "/document",
  EQUIPMENT: "/fixed-asset",
  INVENTORY: "/inventory",
  HUMAN_RESOURCE_INDEX: "/hr/:id",
  HUMAN_RESOURCE: "/hr",
  PROCUREMENT: "/procurement",
  SUB_CONTRACT_LIST: "/sub-contract-list",
  REGISTER_SUB_CONTRACT: "/register-sub-contract",
  FINANCE: "/finance",
  SITE_VISIT: "/site-visit",
  TASK: "/task",
  TENDER: "/tender",
  OPERATION: "/operation",
  LOGIN: "/login",
  PRE_CONTRACT: "/pre-contract",
  REGISTER_PRE_CONTRACT: "/register",
  PRE_CONTRACT_SUMMARY: "/pre-contract/summary",
  PAYMENT: "/payment",
  PAYMENT_SUMMARY: "/payment/:id/:tab",

  STANDARDS: "/standard",

  RESET: "/reset",
  GOOGLE_AUTH_FORM: "/google-auth/:userId",
  EMAIL_CONFIRMATION: "/confirmation",
  CHECKER: "/checker/:hash",
  GOOGLE_AUTH: "/google/auth/:token/:userData",
  CONSULTANT_SUMMARY: "/consultant-summary/:id/:tab",
  CONTRACTOR_PAYMENT: "/contractor-payment/:id/:tab",

  CONTRACTOR_SUMMARY: "/contractor-summary/:id/:tab",
  CLIENT_SUMMARY: "/client-summary/:id/:tab",
  TENDER_SUBMISSION: "/tender-submission/:id/:tab",
  MASTER_SCHEDULE_SUMMARIES: "/master-schedule-summaries/:id/:tab",
  RESOURCE_APPROVAL: "/resource-approval/:id/:tab",
  SITE_HANDOVER: "/site-handover/:id/:tab",

  CONTRACT_SUMMARY: "/contract-summary",
  CONTRACT_BOQ: "/contract-boq",
  VARIATION: "/variation",
  WORK_ITEM: "/work-item",
  MASTER_SCHEDULE: "/master-schedule",
  MASTER_SCHEDULE_SUMMARY: "/master-schedule/:id/:tab",
  PLANS: "/plans",
  REPORTS: "/reports",
  CASH_FLOW: "/cash-flow",
  PRICE_ESCALATION: "/price-escalation",
  EXECUTED_SUMMARY: "/executed-summary",
  MEASUREMENT_CERTIFICATE: "/measurement-certificate",
  PAYMENT_CERTIFICATE: "/payment-certificate",
  REQUESTED_PAYMENTS: "/requested-payments",
  ANALYTICS: "/analytics",
  EDIT: "/edit",
  // CONTRACT: "/HR/Contract",
  // ID: "/HR/ID",

  EMPLOYEE_APPLICATION: "/welcome/:jobId",

  EMPLOYEE_APPLICATION2: "/apply/:jobId",

  EMPLOYEE_APPLICATION_SUCCESS: "/application/success",

  /**
   * Error
   */
  INTERNAL_SERVER_ERROR: "500",
  /**
   * Test
  //  */

  SIGN_UP: "/sign_up",
  HOME_PAGE: "/home",
  DATABASE_TAB: "/database/:tab",
  DATABASE: "/database",
  FEEDBACK_SUCCESS: "/feed-back-response-success",
  FEEDBACK_EXIST: "/feed-back-response-exist",

  PURCHASE_BUDGET_REQUISITION: "/procurement/purchase-budget-requisition",
};

export const ACCOUNT_ROUTE = [
  RouteConstants.DASHBOARD,
  RouteConstants.EVM_DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.FINANCE,
  RouteConstants.STANDARDS,
];
export const HR_ROUTE = [
  RouteConstants.DASHBOARD,
   RouteConstants.EVM_DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.HUMAN_RESOURCE,
  RouteConstants.HUMAN_RESOURCE_INDEX,
  RouteConstants.STANDARDS,
];
export const PROCUREMENT_ROUTE = [
  RouteConstants.DASHBOARD,
   RouteConstants.EVM_DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.PROCUREMENT,
  RouteConstants.INVENTORY,
  RouteConstants.EQUIPMENT,
  RouteConstants.STANDARDS,
];
export const PROJECT_MANAGER_ROUTE = [
  RouteConstants.DASHBOARD,
   RouteConstants.EVM_DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.SUMMARY,
  RouteConstants.REGISTER_PROJECT,
  RouteConstants.SUB_CONTRACT_LIST,
  RouteConstants.REGISTER_SUB_CONTRACT,
  RouteConstants.PROJECT_LIST,
  RouteConstants.PROJECTS,
  RouteConstants.PROJECT_SUMMARY,
  RouteConstants.REPORT,
  RouteConstants.DOCUMENT,
  RouteConstants.REGISTER_PRE_CONTRACT,
  RouteConstants.PRE_CONTRACT,
  RouteConstants.STANDARDS,
];

export const FEATURES = [

  {
    path: "design/structural/file-storage",
    name: "File Storage",
    menu: "structural",
    header: "design",
    tab: "file-storage",
    key: 3,
  },

  {
    path: "design/road/file-storage",
    name: "File Storage",
    menu: "road",
    header: "design",
    tab: "file-storage",
    key: 56,
  },

  {
    path: "design/architecture/file-storage",
    name: "File Storage",
    menu: "architecture",
    header: "design",
    tab: "file-storage",
    key: 6,
  },

  {
    path: "design/plumbing/file-storage",
    name: "File Storage",
    menu: "plumbing",
    header: "design",
    tab: "file-storage",
    key: 9,
  },

  {
    path: "design/mechanical/file-storage",
    name: "File Storage",
    menu: "mechanical",
    header: "design",
    tab: "file-storage",
    key: 12,
  },

  {
    path: "design/electrical/file-storage",
    name: "File Storage",
    menu: "electrical",
    header: "design",
    tab: "file-storage",
    key: 15,
  },

  {
    path: "design/fire-fighting/file-storage",
    name: "File Storage",
    menu: "fire-fighting",
    header: "design",
    tab: "file-storage",
    key: 18,
  },

  {
    path: "design/special-system/file-storage",
    name: "File Storage",
    menu: "special-system",
    header: "design",
    tab: "file-storage",
    key: 21,
  },

  {
    path: "design/sanitary/file-storage",
    name: "File Storage",
    menu: "sanitary",
    header: "design",
    tab: "file-storage",
    key: 24,
  },

  {
    path: "design/other/file-storage",
    name: "File Storage",
    menu: "Other",
    header: "design",
    tab: "file-storage",
    key: 22,
  },

  {
    path: "design/road/file-storage",
    name: "File Storage",
    menu: "Road",
    header: "design",
    tab: "file-storage",
    key: 23,
  },

  {
    path: "design/boq",
    name: "BoQ",
    menu: "boq",
    header: "design",
    tab: "boq",
    key: 25,
  },
  {
    path: "supervision/minutes-of-meeting/minutes-of-meeting",
    name: "Minutes of Meeting ",
    menu: "minutes-of-meeting",
    header: "supervision",
    tab: "minutes-of-meeting",
    key: 26,
  },
  {
    path: "supervision/minutes-of-meeting/minutes-of-meeting-(signed)",
    name: "Minutes of Meeting (Signed) ",
    menu: "minutes-of-meeting",
    header: "supervision",
    tab: "minutes-of-meeting-(signed)",
    key: 27,
  },

  {
    path: "supervision/site-handover/site-handover",
    name: "Site Handover",
    menu: "site-handover",
    header: "supervision",
    tab: "site-handover",
    key: 28,
  },

  {
    path: "supervision/site-diary/site-diary",
    name: "Site Diary",
    menu: "site-diary",
    header: "supervision",
    tab: "site-diary",
    key: 29,
  },
  {
    path: "supervision/site-diary/site-diary-(files)",
    name: "Site Diary (Files)",
    menu: "site-diary",
    header: "supervision",
    tab: "site-diary-(files)",
    key: 30,
  },
  {
    path: "supervision/submittal/submittal",
    name: "Submittal",
    menu: "submittal",
    header: "supervision",
    tab: "submittal",
    key: 31,
  },
  {
    path: "supervision/inspection/inspection-forms",
    name: "Inspection Forms",
    menu: "inspection",
    header: "supervision",
    tab: "inspection-forms",
    key: 32,
  },
  {
    path: "supervision/inspection/inspection",
    name: "Inspection",
    menu: "inspection",
    header: "supervision",
    tab: "inspection",
    key: 33,
  },
  {
    path: "supervision/inspection/work-permit",
    name: "Work Permit",
    menu: "inspection",
    header: "supervision",
    tab: "work-permit",
    key: 34,
  },

  {
    path: "supervision/inspection/inspection-(file)",
    name: "Inspection (File)",
    menu: "inspection",
    header: "supervision",
    tab: "inspection-(file)",
    key: 35,
  },
  {
    path: "supervision/material-test/request-for-test",
    name: "Request For Test",
    menu: "material-test",
    header: "supervision",
    tab: "request-for-test",
    key: 36,
  },
  {
    path: "supervision/material-test/casting",
    name: "Casting",
    menu: "material-test",
    header: "supervision",
    tab: "casting",
    key: 37,
  },

  {
    path: "supervision/material-test/test-results",
    name: "Test Results",
    menu: "material-test",
    header: "supervision",
    tab: "test-results",
    key: 38,
  },

  {
    path: "supervision/material-test/test-evaluation",
    name: "Test Evaluation",
    menu: "material-test",
    header: "supervision",
    tab: "test-evaluation",
    key: 39,
  },
  {
    path: "supervision/material-approval/material-approval",
    name: "Material Approval",
    menu: "material-approval",
    header: "supervision",
    tab: "material-approval",
    key: 40,
  },
  {
    path: "supervision/material-approval/material-approval-(files)",
    name: "Material Approval (Files)",
    menu: "material-approval",
    header: "supervision",
    tab: "material-approval-(files)",
    key: 41,
  },

  {
    path: "supervision/reports/weekly-plan",
    name: "Weekly Plan",
    menu: "reports",
    header: "supervision",
    tab: "weekly-plan",
    key: 42,
  },
  {
    path: "supervision/reports/weekly-report",
    name: "Weekly Report",
    menu: "reports",
    header: "supervision",
    tab: "weekly-report",
    key: 43,
  },
  {
    path: "supervision/reports/monthly-report",
    name: "Monthly Report",
    menu: "reports",
    header: "supervision",
    tab: "monthly-report",
    key: 44,
  },
  {
    path: "supervision/reports/photos-and-videos",
    name: "Photos And Videos",
    menu: "reports",
    header: "supervision",
    tab: "photos-and-videos",
    key: 45,
  },
  {
    path: "supervision/reports/summary-report",
    name: "Summary Report",
    menu: "reports",
    header: "supervision",
    tab: "summary-report",
    key: 46,
  },
  {
    path: "supervision/payment/payment-request",
    name: "Payment Request",
    menu: "payment",
    header: "supervision",
    tab: "payment-request",
    key: 47,
  },
  {
    path: "supervision/payment/payment",
    name: "Payment",
    menu: "payment",
    header: "supervision",
    tab: "payment",
    key: 48,
  },
  {
    path: "supervision/data/data",
    name: "Data",
    menu: "data",
    header: "supervision",
    tab: "data",
    key: 49,
  },
  {
    path: "supervision/other/other",
    name: "Other",
    menu: "other",
    header: "supervision",
    tab: "other",
    key: 54,
  },
  {
    path: "supervision/site-book/site-book",
    name: "Site Book",
    menu: "site-book",
    header: "supervision",
    tab: "site-book",
    key: 50,
  },

  {
    path: "contract-administration/*/claim",
    name: "Contract Administration",
    menu: "*",
    header: "contract-administration",
    tab: "contract-administration",
    key: 51,
  },
  {
    path: "detail/*/detail",
    name: "Detail",
    menu: "*",
    header: "detail",
    tab: "detail",
    key: 52,
  },
];

export const CLIENT_ROUTE = [
  RouteConstants.DASHBOARD,
   RouteConstants.EVM_DASHBOARD,
  RouteConstants.DASHBOARDS,
  RouteConstants.CLIENT_SUMMARY,
  RouteConstants.TENDER_SUBMISSION,
  RouteConstants.REGISTER_PROJECT,
  RouteConstants.SUB_CONTRACT_LIST,
  RouteConstants.REGISTER_SUB_CONTRACT,
  RouteConstants.PROJECT_LIST,
  RouteConstants.PROJECTS,
  RouteConstants.PROJECT_SUMMARY,
  RouteConstants.DOCUMENT,
  RouteConstants.REGISTER_PRE_CONTRACT,
  RouteConstants.PRE_CONTRACT,
  RouteConstants.STANDARDS,
  RouteConstants.INVENTORY,
  RouteConstants.FINANCE,
  RouteConstants.PROCUREMENT,
  RouteConstants.CONTRACTOR_PAYMENT,
  RouteConstants.HUMAN_RESOURCE,
  RouteConstants.HUMAN_RESOURCE_INDEX,
  RouteConstants.MASTER_SCHEDULE_SUMMARY,
  RouteConstants.EQUIPMENT,
  RouteConstants.MIRAB_REPORT,
  RouteConstants.REPORT,
  RouteConstants.OPERATION,
  RouteConstants.TASK,
  RouteConstants.TENDER,
  RouteConstants.MASTER_SCHEDULE_SUMMARIES,
  RouteConstants.SITE_VISIT,
  RouteConstants.RESOURCE_APPROVAL,
  RouteConstants.SITE_HANDOVER,
  RouteConstants.DATABASE,
  RouteConstants.DATABASE_TAB,
];

export const CONSULTANT_ROUTE = [
  RouteConstants.PROJECT_LIST,
  RouteConstants.PROJECTS,
  RouteConstants.PAYMENT,
  RouteConstants.PAYMENT_SUMMARY,
  RouteConstants.CONSULTANT_SUMMARY,
  RouteConstants.PROJECT_SUMMARY,
  RouteConstants.INVENTORY,
  RouteConstants.MASTER_SCHEDULE_SUMMARY,
  RouteConstants.TASK,
  RouteConstants.TENDER,
  RouteConstants.SITE_VISIT,
];

export const CONTRACTOR_ROUTE = [
  RouteConstants.PROJECTS,
  RouteConstants.PROJECT_LIST,
  RouteConstants.CONTRACTOR_SUMMARY,
  RouteConstants.REGISTER_PROJECT,
  RouteConstants.SUB_CONTRACT_LIST,
  RouteConstants.REGISTER_SUB_CONTRACT,
  RouteConstants.PROJECT_SUMMARY,
  RouteConstants.REPORT,
  RouteConstants.DOCUMENT,
  RouteConstants.REGISTER_PRE_CONTRACT,
  RouteConstants.PRE_CONTRACT,
  RouteConstants.STANDARDS,
  RouteConstants.INVENTORY,
  RouteConstants.EQUIPMENT,
  RouteConstants.HUMAN_RESOURCE,
  RouteConstants.HUMAN_RESOURCE_INDEX,
  RouteConstants.CONTRACTOR_PAYMENT,
  RouteConstants.MASTER_SCHEDULE_SUMMARY,
  RouteConstants.TASK,
  RouteConstants.TENDER,
  RouteConstants.SITE_VISIT,
  RouteConstants.SITE_HANDOVER,
];
